import { styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addProduct } from "../../feature/products/addProductSlice";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useRef } from "react";

const Input = styled("input")({
  display: "none",
});

const ProductInfoForm = ({
  productInfo,
  setProductInfo,
  error,
  selectedImages,
  setSelectedImages,
  isInputEmpty,
}) => {
  // const validate = Yup.object({
  //   productName: Yup.string()
  //     .max(25, "Must be 25 character of less")
  //     .required("Required"),
  //   productBrand: Yup.string()
  //     .max(50, "Must be 50 character of less")
  //     .required("Required"),
  //   productAmount: Yup.number().required("Required"),
  //   productDiscountPrice: Yup.number().required,
  //   productTag: Yup.string()
  //     .max(20, "Must be 20 cahracter of less")
  //     .required("Required"),
  // });
  const { categories } = useSelector((state) => state.categories);

  const onSelectedFile = (event) => {
    console.log("file", event.target.files[0]);

    if (event.target.files.length !== 0) {
      const image = URL.createObjectURL(event.target.files[0]);
      setSelectedImages(image);
      setProductInfo({
        ...productInfo,
        productImage: event.target.files[0],
      });
    }
    URL.revokeObjectURL(event.target.files[0]);
  };

  const {
    productCategory,
    productName,
    productBrand,
    productAmount,
    productDiscountPrice,
    productDiscountPercentage,
    productImage,
    productTag,
  } = productInfo;

  // if (!isLoading) return setProducts(transaction);
  return (
    <>
      <Stack direction='column' spacing={2}>
        {error === "" ? null : <span style={{ color: "red" }}>{error}</span>}
        <TextField
          fullWidth
          name='state'
          error={productCategory === "" && isInputEmpty}
          helperText={isInputEmpty && productCategory === "" ? "Empty" : null}
          select
          SelectProps={{ native: true }}
          value={productCategory}
          variant='outlined'
          onChange={(e) => {
            setProductInfo({ ...productInfo, productCategory: e.target.value });
          }}
        >
          <option value=''>Select Category</option>
          {categories?.map((category) => (
            <option key={category.id} value={category.id}>
              {category.category_name}
            </option>
          ))}
        </TextField>

        <TextField
          fullWidth
          label='Product Name'
          value={productName}
          id='product_name'
          error={productName === "" && isInputEmpty}
          helperText={isInputEmpty && productName === "" ? "Empty" : null}
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productName: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Brand/Vendor'
          value={productBrand}
          id='product_brand'
          error={productBrand === "" && isInputEmpty}
          helperText={isInputEmpty && productBrand === "" ? "Empty" : null}
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productBrand: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          label='Product Price'
          value={productAmount}
          id='product_amount'
          type='number'
          error={isInputEmpty && productAmount === ""}
          helperText={isInputEmpty && productAmount === "" ? "Empty" : null}
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productAmount: e.target.value,
            });
          }}
        />

        <TextField
          fullWidth
          label='Product Discounted Price'
          value={productDiscountPrice}
          id='product_discount_price'
          type='number'
          error={isInputEmpty && productDiscountPrice === ""}
          helperText={
            isInputEmpty && productDiscountPrice === "" ? "Empty!" : null
          }
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productDiscountPrice: e.target.value,
            });
          }}
        />
        <TextField
          fullWidth
          InputProps={{ readOnly: true }}
          label='Product Discount Percentage'
          type='number'
          value={productDiscountPercentage}
          id='product_discount_price'
          error={isInputEmpty && productDiscountPercentage === ""}
          helperText={
            isInputEmpty && productDiscountPercentage === "" ? "Empty! " : null
          }
        />

        <TextField
          fullWidth
          label='Product Tag'
          value={productTag}
          id='product_tag'
          error={isInputEmpty && productTag === ""}
          helperText={isInputEmpty && productTag === "" ? "Empty!" : null}
          onChange={(e) => {
            setProductInfo({
              ...productInfo,
              productTag: e.target.value,
            });
          }}
        />

        <Box>
          <label htmlFor='upload-file'>Upload Product Image</label>
          <br />
          {isInputEmpty && productImage === null ? (
            <span style={{ color: "red", display: "block" }}>
              You didn't upload a Image!
            </span>
          ) : null}
          <Button variant='contained' component='label'>
            Choose File
            <Input
              accept='image/*'
              id='upload-file'
              type='file'
              onChange={onSelectedFile}
              // hidden
            />
          </Button>
          <br />
          <Box>
            {selectedImages !== null && (
              <img src={selectedImages} alt='' height='200' />
            )}
          </Box>
        </Box>
      </Stack>
    </>
  );
};

export default ProductInfoForm;
